module.exports = __webpack_public_path__ + "static/SGWB-privacy-beleid-43d719dade425b0563cf258ed6c6219b.pdf";